import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import BackgroundImage from "./components/1_atoms/BackgroundImage";

import Home from "./components/pages/Home";

function App() {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Home />

      <BackgroundImage />

      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
